export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-secondary-100">
      <div className="container-x py-10 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          {/* brand */}
          <div className="md:col-span-1">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="grid h-9 w-9 place-items-center rounded-xl bg-accent-500 text-lg text-background-50">
                <i className="ri-arrow-left-right-line"></i>
              </span>
              <span className="font-heading text-lg font-extrabold tracking-tight text-foreground-950">
                吃瓜<span className="text-primary-600">网爆</span>
              </span>
            </a>
            <p className="mt-3 max-w-xs text-[13px] leading-relaxed text-foreground-600">
              吃瓜网爆猛料汇总、爆料合集与黑料大全都按主题码好归档，实锤集合附前因后果与锤点，点开即可按类切瓜。
            </p>
          </div>

          {/* quick links */}
          <div>
            <h4 className="text-sm font-bold text-foreground-950">按内容挑</h4>
            <ul className="mt-3 space-y-2 text-[13px] text-foreground-600">
              {["实锤集合", "爆料合集", "黑料大全", "人物档案", "实时快讯"].map((t) => (
                <li key={t}>
                  <a href="#top" className="transition-colors hover:text-primary-600">
                    {t}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-bold text-foreground-950">按主题切</h4>
            <ul className="mt-3 space-y-2 text-[13px] text-foreground-600">
              {["直播翻车", "带货价差", "舞台对口型", "选秀旧料", "综艺剧本"].map((t) => (
                <li key={t}>
                  <a href="#topics" className="transition-colors hover:text-primary-600">
                    {t}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-bold text-foreground-950">关于本站</h4>
            <p className="mt-3 text-[13px] leading-relaxed text-foreground-600">
              按类码好，省得来回翻。本站为演示页面，人物与事件均为演示拟名，不涉及真实举报或侵权信息。
            </p>
            <div className="mt-4 flex items-center gap-2 text-xs text-foreground-500">
              <i className="ri-shield-check-line text-accent-600"></i>
              存疑帖会标注跟进，不抢跑定性
            </div>
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-background-300/70 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">© 2026 吃瓜网爆 · 仅供娱乐讨论，请理性吃瓜</p>
          <div className="flex flex-wrap items-center gap-4 text-xs text-foreground-500">
            <a href="#top" className="hover:text-primary-600 whitespace-nowrap">
              免责声明
            </a>
            <a href="#top" className="hover:text-primary-600 whitespace-nowrap">
              内容申诉
            </a>
            <a href="#top" className="hover:text-primary-600 whitespace-nowrap">
              反馈建议
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}